var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partner-box"},[_c('router-link',{attrs:{"to":`${_vm.$t('routes.partner.path')}/${_vm.data.code}`}},[_c('figure',{staticClass:"partner-logo fit-image contain"},[_c('img',{attrs:{"src":_vm.getImage(_vm.data.logo.filename)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }